import React, { useState } from 'react';
import { Card, CardBody, Nav, NavItem, NavLink, Table, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

export default function InvoicesTabs({ subscriptionPayment = [] }) {
  const [activeTab, setActiveTab] = useState('invoices');

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Card className="mt-4">
      <CardBody>
        <h3> Invoices</h3>

        <TabContent activeTab={activeTab}>
          {/* -------------------- INVOICES TAB -------------------- */}
          <TabPane tabId="invoices">
            <Table responsive borderless>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Invoice number</th>
                  <th>Total due</th>
                  {/* <th>Invoice</th> */}
                </tr>
              </thead>
              <tbody>
                {subscriptionPayment.length > 0 ? (
                  subscriptionPayment.map((item) => (
                    <tr key={item.id}>
                      <td>{new Date(item.date).toLocaleDateString()}</td>
                      <td>INV-{item.id}</td>
                      <td>£{item.amount}</td>
                      {/* <td>
                        <a href="#">View</a>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-3">
                      No invoices found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </TabPane>

          {/* -------------------- TRANSACTIONS TAB -------------------- */}
          <TabPane tabId="transactions">
            <Table responsive borderless>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Transaction ID</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {subscriptionPayment.length > 0 ? (
                  subscriptionPayment.map((item) => (
                    <tr key={item.id}>
                      <td>{new Date(item.date).toLocaleDateString()}</td>
                      <td>{item.squarePaymentId}</td>
                      <td>£{item.amount}</td>
                      <td>Paid</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-3">
                      No transactions found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  );
}
